import moment from 'moment';

export function dateWithFormat(timestamp: moment.MomentInput | string, format = 'YYYY-MM-DD') {
  return moment(timestamp).format(format);
}

export function datehhmmss(timestamp: moment.MomentInput) {
  return moment(timestamp).format('HH:mm:ss');
}
export function getDateQuarter(timestamp: moment.MomentInput) {
  return moment(timestamp).quarter();
}

export function dateNoHyphenString(timestamp: string) {
  return timestamp.replaceAll('-', '');
}

export function dateHyphenYYYYMMDD(timestamp: moment.MomentInput | string) {
  return moment(timestamp).format('YYYY-MM-DD');
}

export function dateFormat(date: string, format: string) {
  return date ? moment(date).format(format) : '';
}